import { getGmt0 } from '../../../utils/dateUtility';
import moment from 'moment';

/** Sem `storageName` o anexo não é baixável: esta versão local serve só para a bolha
 *  mostrar o que foi enviado enquanto os anexos persistidos não chegam da API.
 *  Ver Thumbnail, que trata esse caso renderizando apenas o ícone do formato.
 */
export const buildLocalAttachments = (files) => {
    return (files || []).map((file, index) => ({
        id: -(index + 1),
        messageId: null,
        fileName: file.name,
        storageName: '',
        contentType: file.type,
        sizeBytes: file.size,
        width: null,
        heigth: null,
        url: null
    }))
}

export const internalChatMessageObject = (contact, message) => {
    const attachments = message.files && message.files.length > 0
        ? buildLocalAttachments(message.files)
        : null;

    return {
        createdAt: getGmt0(moment()),
        userReceiver: {
            userId: contact.userId,
            name: contact.name,
        },
        isSent: true,
        messageText: message.messageText,
        externalReference: message.externalReference,
        messageStatus: null,
        attachments: attachments
    }
}
